export default __webpack_public_path__ + "static/media/8.763a5d17.svg";